import { InputHTMLAttributes } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { PropsWithTestId } from '../../../../../types';
import { useKeywordSearch } from '../../../../../hooks';
import { SiteDiscoveryValues } from '../../../../../store/features/discovery';
import styles from './KeywordSearch.module.scss';
import useBrand from '../../../../../hooks/useBrand';

type CustomInputType = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'value' | 'onChange' | 'onInput' | 'form'
>;

export interface KeywordSearchProps
  extends CustomInputType,
    ReturnType<typeof useKeywordSearch> {
  theme: 'normal' | 'bordered';
  onResetValue?: () => void;
  form?: UseFormReturn<SiteDiscoveryValues>;
}

export function KeywordSearch(props: PropsWithTestId<KeywordSearchProps>) {
  const {
    value,
    setValue,
    handleChange,
    handleKeyDown,
    handleSearch,
    handleReset,
    onResetValue,
    form,
    theme,
    testId,
    ...inputProps
  } = props;
  const { t } = useTranslation();
  const { secondaryColor } = useBrand();

  const handleSearchValue = () => {
    handleSearch(value);
  };

  const handleResetValue = () => {
    handleReset();

    if (onResetValue) {
      onResetValue();
    }
  };

  return (
    <div className={styles.wrapper} data-testid={testId}>
      <div
        className={styles.inputWrapper}
        style={{ border: `1px solid ${secondaryColor}` }}
      >
        <input
          type="text"
          value={value}
          onInput={handleChange}
          onKeyDown={handleKeyDown}
          placeholder={t('event.search')}
          {...inputProps}
        />
        {value && (
          <span
            onClick={handleResetValue}
            className={cn(styles.clearIcon, 'material-icons')}
            style={{ color: secondaryColor }}
          >
            clear
          </span>
        )}
        <div
          style={{ backgroundColor: secondaryColor }}
          onClick={handleSearchValue}
          className={styles.button}
        >
          <span className={cn('material-icons', styles.searchIcon)}>
            search
          </span>
        </div>
      </div>
    </div>
  );
}

KeywordSearch.defaultProps = {
  theme: 'normal',
  testId: 'keyword-search',
};
